var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "15px" },
          attrs: {
            data: _vm.dspData,
            "summary-method": _vm.getSummaries,
            "show-summary": "",
            size: "mini",
            height: "calc(100vh - 370px)"
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "num_affaire", label: "N° Affaire", width: "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "router-link",
                      { attrs: { to: "/affaire/" + scope.row.id } },
                      [
                        _c("el-link", { attrs: { type: "primary" } }, [
                          _vm._v(_vm._s(scope.row.num_affaire))
                        ])
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "nom", label: "Affaire", width: "300" }
          }),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: _vm.libCol1 } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "mtTotalProvisionsYmoins1",
                  label: "Total aléas",
                  width: "120",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("toCurrency")(
                              _vm._f("toSumMt")(
                                scope.row.mtTotalProvisionsYmoins1,
                                "mtTotalProvisionsYmoins1",
                                _vm.sums
                              )
                            )
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: _vm.libCol2 } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "mtTotalProvisionsMmoins1",
                  label: "Total aléas",
                  width: "120",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("toCurrency")(
                              _vm._f("toSumMt")(
                                scope.row.mtTotalProvisionsMmoins1,
                                "mtTotalProvisionsMmoins1",
                                _vm.sums
                              )
                            )
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table-column",
            { attrs: { label: _vm.libCol3 } },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "mtTotalProvisions",
                  label: "Total aléas",
                  width: "120",
                  align: "right"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          _vm._s(
                            _vm._f("toCurrency")(
                              _vm._f("toSumMt")(
                                scope.row.mtTotalProvisions,
                                "mtTotalProvisions",
                                _vm.sums
                              )
                            )
                          )
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }